import { AHButton, AHSeparator, Box } from "arkh";
import React, { useCallback, useState } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";

import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

import { KPIAdminTeamHeader } from "../components/KPIAdminTeamHeader";
import { KPIEditScreenProps } from "./KPIEditParamList";
import { KPIEditAdminTeamMutation } from "./__generated__/KPIEditAdminTeamMutation.graphql";
import { KPIEditAdminTeamQuery } from "./__generated__/KPIEditAdminTeamQuery.graphql";
import { TeamSelectList } from "widgets/src/TeamSelectList";

const KPI_EDIT_ADMIN_TEAM_QUERY = graphql`
  query KPIEditAdminTeamQuery($routineId: ID!) {
    store {
      id
      publicTeams {
        ...TeamSelectList_Team
      }
    }
    routine(id: $routineId) {
      id
      team {
        id
      }
    }
  }
`;

export function KPIEditAdminTeam(
  props: KPIEditScreenProps<"KPIEditAdminTeam">
) {
  const data = useLazyLoadQuery<KPIEditAdminTeamQuery>(
    KPI_EDIT_ADMIN_TEAM_QUERY,
    {
      routineId: props.route.params.routineId,
    },
    { fetchKey: "" }
  );
  const [selected, setSelected] = useState(data.routine!.team.id);

  const insets = useSafeAreaInsets();

  const [saveAdminTeam, loading] = useMutation<KPIEditAdminTeamMutation>(
    graphql`
      mutation KPIEditAdminTeamMutation($routineId: ID!, $teamId: ID!) {
        routine(id: $routineId) {
          update(input: { setTeamId: $teamId }) {
            routine {
              id
              team {
                id
              }
            }
          }
        }
      }
    `
  );
  const onSaveAdminTeam = useCallback(() => {
    saveAdminTeam({
      variables: {
        routineId: props.route.params.routineId,
        teamId: selected,
      },
      onCompleted: props.navigation.goBack,
    });
  }, [
    props.navigation.goBack,
    props.route.params.routineId,
    saveAdminTeam,
    selected,
  ]);
  const intl_token = useIntlTokens();
  return (
    <>
      <TeamSelectList
        contentBox={{
          spaceTop: "medium",
        }}
        insets={{ top: 0, bottom: 0, left: 0, right: 0 }}
        onItemPress={(itemId, selected) => {
          if (!selected) {
            setSelected(itemId);
          }
        }}
        selected={[selected]}
        teams={data.store.publicTeams}
        ListHeaderComponent={<KPIAdminTeamHeader />}
      />
      <AHSeparator />
      <Box insets={{ bottom: insets.bottom }} space="medium">
        <AHButton
          disabled={data.routine?.team.id === selected}
          title={intl_token.Save}
          loading={loading}
          onPress={onSaveAdminTeam}
          themeType="primary"
        />
      </Box>
    </>
  );
}
